import { useRouter } from 'vue-router'

// Shared internal-link interception for v-html'd editorial content (ContentRegion + ContentText).
// Clicks on internal anchors inside content HTML route client-side instead of triggering a full page
// reload; links that don't resolve to a real SPA route (legacy handoffs, external links, downloads,
// target=_blank) fall through untouched.
export function useContentLinks() {
  const router = useRouter()

  function onContentClick(e: MouseEvent) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)
      return
    const anchor = (e.target as HTMLElement)?.closest('a')
    if (!anchor) return
    const href = anchor.getAttribute('href')
    if (!href || href.startsWith('#')) return
    if (anchor.target && anchor.target !== '_self') return
    if (anchor.hasAttribute('download')) return
    // Same-origin, path-only links only.
    const url = new URL(href, window.location.origin)
    if (url.origin !== window.location.origin) return
    // App is served under /app; strip that base before resolving against the router.
    const path = url.pathname.replace(/^\/app/, '') || '/'
    const resolved = router.resolve(path + url.search + url.hash)
    if (resolved.matched.length === 0 || resolved.name === 'not-found') return
    e.preventDefault()
    router.push(resolved.fullPath)
  }

  return { onContentClick }
}
